/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { GlobalNav } from '@zcode/state-type'

import { GLOBAL_NAV_SLICE_NAME } from './constants'

const initialState: GlobalNav = {
  meta: {
    fetchingKey: null,
    currentKey: null,
  },
}

export const globalNavSlice = createSlice({
  name: GLOBAL_NAV_SLICE_NAME,
  initialState,
  reducers: {
    receiveGlobalNavLinks: (state, { payload }: PayloadAction<GlobalNav['links']>) => {
      return {
        ...state,
        links: payload,
        meta: { fetchingKey: null, currentKey: state.meta.fetchingKey },
      }
    },
    startFetchingLinks: (state, { payload }: PayloadAction<string>) => {
      return { ...state, meta: { ...state.meta, fetchingKey: payload } }
    },
    doneFetchingLinks: (state) => {
      return { ...state, meta: { ...state.meta, fetchingKey: null } }
    },
  },
})

export const { actions: globalNavActions } = globalNavSlice
